<template>
  <div class="zsxqy project_detail">
    <mt-header title="Exhibitor Details">
      <span slot="left" @click="()=>this.$router.push('/exhibitor')">
        <i class="iconfont icon-left"></i>
        Return
      </span>
    </mt-header>
    <div class="mintHeader"></div>
    <div class="detailContent">
      <div>
        <div class="zsbt">
          <div>
            <img :src="datas.corplogo_cn" alt="" />
          </div>
          <p>{{datas.corpname_en}}</p>
        </div>
        <div class="abs">
          <h5>Exhibitor Introduction</h5>
          <p>{{datas.introduct_en}}</p>
        </div>
        <div class="contact">
          <h5>Contact Information</h5>
          <p><span class="span1"><i class="iconfont icon-daohang1"></i>Add:</span><span>{{datas.address_en}}</span></p>
          <p><span class="span1"><i class="iconfont icon-dianhua3"></i>Tel:</span><span>{{datas.phone}}</span></p>
          <p><span class="span1"><i class="iconfont icon-chuanzhen"></i>Fax:</span><span>{{datas.fax}}</span></p>
          <p><span class="span1"><i class="iconfont icon-youxiang2"></i>E-mail:</span><span>{{datas.email}}</span></p>
          <p><span class="span1"><i class="iconfont icon-wangzhi"></i>Website:</span><span>{{datas.website}}</span></p>
        </div>
        <div class="product" v-if="xgcp.list.length">
          <h5>{{xgcp.name}}</h5>
          <ul>
            <li class="liItemR" v-for="item in xgcp.list" :key="item.id" @click="$router.push('/exhibit/details/'+item.id+'/'+item.ocid)">
              <div>
                <img :src="item.img_url" alt="" />
              </div>
              <p>{{item.proname_cn}}</p>
              <i class="iconfont collect" :class="like1?'icon-shoucang':'icon-shoucang_pre'" @click.stop="modifyLike('传入这一项','下标')"></i>
            </li>
          </ul>
        </div>
        
      </div>
    </div>
    <ul class="footer">
      <li @click="isCollect(datas.ocid)">
        <div>
          <img v-show="like1*1==1" src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/like.png" alt="" />
          <img v-show="like1*1==2" src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/like_1.png" alt="" />
        </div>
        <span>Favorites</span>
      </li>
      <li @click="dakai">
        <div><img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/pack_1.png" alt=""/></div>
        <span>Contact</span>
      </li>
      
    </ul>
    <div class="mask" v-if="popup1">
      <div class="popup">
        <h2>Make an Appointment</h2>
        <p>Appointment Date：</p>
        <button class="btnTime" @click="()=>{this.$refs.picker.open();}">
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/date.png" alt=""/>
          {{form.date}}
        </button>
        <p>Leave a Message：</p>
        <textarea v-model="form.connet" placeholder="Input Your Message"></textarea>
        <div class="btn_group">
          <button @click="popup1=false">Cancel</button>
          <button @click="isCorpApp(list.ocid)">Request A Meeting</button>
        </div>
      </div>
      <mt-datetime-picker
        ref="picker"
        type="date"
        year-format="{value} years"
        month-format="{value} month"
        date-format="{value} day"
        @confirm="handleChange">
      </mt-datetime-picker>
    </div>
  </div>
</template>

<script>
import { Header, Toast, DatetimePicker } from 'mint-ui';
import "mint-ui/lib/header/style.css"
import { reqExhibitorDetail, reqCorpColl, reqCorpCollDo, reqCorpAppDo } from "../../../api";
export default {
  components:{
    'mt-header':Header,
    'mt-datetime-picker':DatetimePicker,
  },
  data () {
    return {
      like1:1,
      meet:0,
      list:[1,2,3,4,5,6,7,8,9,10],
      datas:{},//详情
      xgcp:{list:[],name:""},//相关产品
      id:Number,
      ocid:Number,
      form:{
        id:0,
        date:"",
        connet:""
      },
      popup1:false
    }
  },
  mounted(){
    let id = this.$route.path.split('/')
    this.id=id[id.length-2]*1
    this.ocid=id[id.length-1]*1
    this.form.id = id[id.length - 1] * 1;
    this.reqDetail(this.id)
    this.initCollect(this.ocid)
    // this.initCorpApp(this.ocid)
  },
  methods:{
    modifyLike(item,i){
      console.log(item,i);
    },
    // 请求列表
    async reqDetail(id){
      const response = await reqExhibitorDetail(id)
      if(response.code==0){
          this.datas=response.resilt[0]
          this.xgcp = {
            name:"Products Display",
            list:response.resilt[1]
          }
      }else{
        this.$router.push("/")
      }
    },
    // 初始获取收藏状态
    async initCollect(ocid){
      const response = await reqCorpColl(ocid)
      if (response.code==0) {
        this.like1=response.is_coll
      }else{
        this.like1 = 1
      }
    },
    // 修改收藏状态
    async isCollect(ocid){
      const response = await reqCorpCollDo(ocid)
      if (response.code==0) {
        this.like1=response.is_coll
      }else{
        this.like1 = 1
      }
    },
    dakai(){
      let time = new Date()
      this.form.date = time.getFullYear()+'-'+time.getMonth()+'-'+time.getDate()
      this.popup1=true
      this.form.connet=''
    },
    // 修改约见状态
    async isCorpApp(){
      // console.log(this.form);
      if(this.form.connet==''){
        Toast({message: 'Please input your message',position: 'center',});
        return
      }
      const response = await reqCorpAppDo(this.form)
      if (response.code==0) {
        Toast({message: 'Succeed',position: 'center',});
        this.popup1=false
      }else if(response.code == 2){
        Toast({ message: "Appointment is successful", position: "center" });
        this.popup1=false
      }
    },
    handleChange(value) {
      this.form.date = this.formatDate(value);
      console.log(this.form.date); // 20170101
    },
    formatTen(num) {
        return num > 9 ? (num + "") : ("0" + num);
      },
    formatDate(date) {
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      return year+'-'+this.formatTen(month) +'-'+ this.formatTen(day);
    }
  }
}
</script>

<style scoped>
  .zstj{
    height: 100%;  
    background-color: #f3f3f3;  
  }
  .newListPage{
    height: 100%;
    background-color: white;
    overflow: hidden;
  }
  .mint-header{
    height: 40px;
    background-color: #008baf;
    position: relative;
    z-index: 10;
  }
  .detailContent{
    height: calc(100vh - 90px);
    overflow-y: auto;
    /* overflow: hidden; */
    position: relative;
    z-index: 10;
  }
  .zsbt{
    height: 120px;
    box-sizing: border-box;
    padding-top: 30px;
    overflow: hidden;
    box-shadow: 0 5px 5px -5px rgba(0, 0, 0, .3);
    text-align: center;
  }
  .zsbt div{
    height: 30px;
    margin-bottom: 10px;
  }
  .zsbt p{
    font-size: 16px;
  }
  h5{
    text-align: center;
    font-size: 16px;
    padding: 25px 0 15px;
  }
  .abs{
    padding:  0 10px;
  }
  .abs p{
    text-indent: 2em;
    font-size: 13px;
    line-height: 23px;
    /* letter-spacing: 1px; */
  }
  .contact{
    background-color: white;
    margin: 30px 10px;
    box-shadow: 0 0 5px rgba(0, 0, 0, .3);
    padding: 0 30px 30px 20px;
  }
  .contact h5{
    color: #1797b8;
  }
  .contact p{
    margin-bottom: 15px;
    padding-left: 70px;

  }
  .contact .span1{
    width: 70px;
    margin-left: -70px;
    display: inline-block;
  }
  .span1 i{
    margin-right: 4px;
    color: #008baf;
  }
  .product ul{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 10px;
  }
  .liItemR{
    position: relative;
    width: 172.5px;
    padding: 20px;
    margin-bottom: 10px;
    background-color: white;
    box-sizing: border-box;
    border-radius: 5px;
  }
  .liItemR>div{
    width: 132.5px;
    height: 132.5px;
  }
  .liItemR>p{
    text-align: center;
    padding-top: 8px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .liItemR>i{
    position: absolute;
    right: 5px;
    top: 5px;
    font-size: 21px;
    color: #dcdcdc;
  }


  .footer{
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 50px;
    text-align: center;
    display: flex;
    justify-content: space-around;
    box-shadow: 0 5px 5px 5px rgba(0, 0, 0, .3) ;
    background-color: #008baf;
  }
  .footer li{
    padding-top: 3px;
    list-style: none;
    width: 50%;
    border-left: 1px solid white;
    color: white;
  }
  .footer li :first-child{
    border: none;
  }
  .footer li div{
    width: 27px;
    margin: 0 auto 2px;
  }
  .footer li i{
    margin: 0 auto;
    font-size: 27px;
    display: block;
    color: #8b8a8a;
  }
  .footer li .hue{
    color: #ff840c;
  }
</style>
<style scoped>
  .mask{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .3);
    z-index: 11;
  }
  .popup{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 90%;
    /* height: 300px; */
    background-color: white;
    border-radius: 4px;
    padding: 10px;
    font-size: 14px;
  }
  .popup h2{
    font-size: 14px;
    color: #008baf;
    font-weight: 600;
  }
  .popup p{
    line-height: 24px;
    padding: 6px 0;
  }
  .btnTime{
    text-align: left;
    width: 100%;
    padding: 6px 14px;
    border-radius: 4px;
    background-color: white;
    border: 1px solid #bbb;
    box-shadow: none;
    outline: none;
    color: #bbb;
    vertical-align: middle;
    line-height: 20px;
  }
  .btnTime img{
    width: 18px;
    margin-right: 10px;
    vertical-align: middle;
  }
  .popup textarea{
    width: 100%;
    padding: 10px;
    line-height: 20px;
    min-height: 100px;
    border: 1px solid #bbb;
  }
  .btn_group{
    width: 100%;
    display: flex;
    justify-content: space-around;
    padding: 20px 0 10px;
  }
  .btn_group button{
    line-height: 40px;
    box-shadow: none;
    outline: none;
    border: none;
    color: #008baf;
    background-color: white;
    border: 1px solid #008baf;
    width: 40%;
    font-size: 12px;
  }
  .btn_group button+button{
    background-color: #008baf;
    color: white;
  }
</style>